import * as angular from "angular";
import * as _ from "lodash";
import {LogisticsVehicle} from "../models/logistics-vehicle.model";
import {VehicleOwnershipStatusType} from "../types/vehicle-ownership-status.type";
import {LogisticsVehicleStatusType} from "../types/logistics-vehicle-status.type";
import {VehicleType} from "../../commons/types/vehicle.type";
import {AgentModel} from "../../agents/angular/models/agent.model";

export class LogisticsVehiclesDialogsService {

  /* @ngInject */
  constructor(private $mdDialog, private VehiclesConstants, private $log, private moment, private splitService, private uploadFile) {
  }

  createVehicle(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-logistic-vehicle-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true,
      controller: function ($scope) {

        $scope.createdLogisticVehicle = {};
        /////////////////////////////////////////////////////////////////

        $scope.onChanges = ({logisticVehicle}) => {
          $scope.createdLogisticVehicle = angular.copy(logisticVehicle);
        }

        $scope.cancel = self.$mdDialog.cancel;
        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.createdLogisticVehicle);
            }
          } else {
            self.$log.error('Form resolved to undefined!. --> logisticsVehiclesDialogService@createVehicle@create');
          }
        }
      }
    })
  }

  editVehicleBasics(event, logisticsVehicle: LogisticsVehicle) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-logistics-vehicle-basics-dialog.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.loading = false;
        $scope.logisticsVehicle = angular.copy(logisticsVehicle);
        $scope.logisticsVehicle.branchIds = logisticsVehicle.branchIds || _.map(logisticsVehicle.branchReferences, 'id');

        $scope.cancel = self.$mdDialog.cancel;
        $scope.confirm = confirm;

        // ******************************
        // External methods
        // ******************************

        $scope.onBranchesSelect = (branchIds) => {
          $scope.logisticsVehicle.branchIds = branchIds;
        }

        $scope.confirm = (form) => {

          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({logisticsVehicle: $scope.logisticsVehicle});
            }
          }
        }
      }
    })
  }

  editVehicleType(event, logisticsVehicle: LogisticsVehicle, vehicleType) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-logistics-vehicle-type-dialog.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {
        $scope.loading = false;
        $scope.vehicleType = angular.copy(vehicleType);
        $scope.logisticsVehicle = angular.copy(logisticsVehicle);

        if (!$scope.logisticsVehicle.vehicleCapacity?.dimensions && !!vehicleType.vehicleCapacity?.dimensions) {

          if (!$scope.logisticsVehicle.vehicleCapacity) {
            $scope.logisticsVehicle.vehicleCapacity = {};
          }

          $scope.logisticsVehicle.vehicleCapacity.dimensions = angular.copy(vehicleType.vehicleCapacity.dimensions);
        }

        $scope.setVehicleWeights = () => {
          if (!_.isNumber(_.get($scope.logisticsVehicle, 'vehicleCapacity.weight'))) {
            _.set($scope.logisticsVehicle, 'vehicleCapacity.weight', $scope.vehicleType?.vehicleCapacity?.weight)
          }
          if (!_.isNumber(_.get($scope.logisticsVehicle, 'weight'))) {
            _.set($scope.logisticsVehicle, 'weight', +$scope.vehicleType?.weight)
          }
          if (!_.isNumber(_.get($scope.logisticsVehicle, 'allowedWeight'))) {
            _.set($scope.logisticsVehicle, 'weight', +$scope.vehicleType?.allowedWeight)
          }
        }

        $scope.setVehicleWeights();

        $scope.cancel = self.$mdDialog.cancel;
        $scope.confirm = confirm;

        // ******************************
        // External methods
        // ******************************
        $scope.onVehicleTypeChanged = (vehicle) => {
          $scope.logisticsVehicle.vehicleTypeId = _.get(vehicle, 'id');
          $scope.logisticsVehicle.dimensions = _.get(vehicleType, 'dimensions', {});
          $scope.vehicleType = vehicle;
          $scope.setVehicleWeights();
        }

        $scope.onChangeDimensions = (dimensions) => {
          $scope.logisticsVehicle.dimensions = dimensions;
        }

        $scope.confirm = (form) => {

          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({logisticsVehicle: $scope.logisticsVehicle});
            }
          }
        }
      }
    })
  }

  editVehicleBackground(event, logisticsVehicle: LogisticsVehicle) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-logistics-vehicle-background-dialog.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.loading = false;
        $scope.logisticsVehicle = angular.copy(logisticsVehicle);
        $scope.vehicleMakes = self.VehiclesConstants.makes;

        $scope.cancel = self.$mdDialog.cancel;
        $scope.confirm = confirm;

        // ******************************
        // External methods
        // ******************************

        $scope.onDateChange = (selectedTimeStamp, path) => {
          if (_.isUndefined(selectedTimeStamp)) {
            _.unset($scope.logisticVehicle, path);
          } else {
            const dateString = self.moment(selectedTimeStamp).format("YYYY-MM-DD");
            _.set($scope.logisticVehicle, path, dateString);
          }
        }

        $scope.confirm = (form) => {

          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({logisticsVehicle: $scope.logisticsVehicle});
            }
          }
        }
      }
    })
  }

  editVehicleStatusAndInformation(event, logisticsVehicle: LogisticsVehicle) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-logistics-vehicle-status-and-information-dialog.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.logisticsVehicle = angular.copy(logisticsVehicle);
        $scope.vehicleOwnershipStatusTypesList = Object.values(VehicleOwnershipStatusType);

        $scope.cancel = self.$mdDialog.cancel;
        $scope.confirm = confirm;

        // ******************************
        // External methods
        // ******************************

        $scope.onDateChange = (selectedTimeStamp, path) => {
          if (_.isUndefined(selectedTimeStamp)) {
            _.unset($scope.logisticsVehicle, path);
          } else {
            const dateString = self.moment(selectedTimeStamp).format("YYYY-MM-DD");
            _.set($scope.logisticsVehicle, path, dateString);
          }
        }


        $scope.onVehicleOwnershipStatus = (ownershipType) => {
          if (_.isUndefined(ownershipType)) {
            _.unset($scope.logisticsVehicle, 'ownershipType');
          }
        }

        $scope.kilometersChanged = ({value, path}) => {
          _.set($scope.logisticsVehicle, path, value);
        }

        $scope.confirm = (form) => {

          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({logisticsVehicle: $scope.logisticsVehicle});
            }
          }
        }
      }
    })
  }

  editVehicleInsuranceInformation(event, logisticsVehicle: LogisticsVehicle) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-logistics-vehicle-insurance-information-dialog.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.todayDate = self.moment();
        // $scope.siteDistanceUnit = this.splitService.getSiteDistanceSmallUnit() === 'Meter' ? "Km" : "Mi";
        $scope.siteDistanceUnit = self.splitService.getSiteDistanceLargeUnit(true);

        $scope.logisticsVehicle = angular.copy(logisticsVehicle);
        $scope.vehicleOwnershipStatusTypesList = Object.values(VehicleOwnershipStatusType);

        $scope.cancel = self.$mdDialog.cancel;
        $scope.confirm = confirm;

        // ******************************
        // External methods
        // ******************************

        $scope.onDateChange = (selectedTimeStamp, path) => {
          if (_.isUndefined(selectedTimeStamp)) {
            _.unset($scope.logisticsVehicle, path);
          } else {
            const dateString = self.moment(selectedTimeStamp).format("YYYY-MM-DD");
            _.set($scope.logisticsVehicle, path, dateString);
          }
        }

        $scope.kilometersChanged = ({value, path}) => {
          _.set($scope.logisticsVehicle, path, value);
        }

        $scope.confirm = (form) => {

          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({logisticsVehicle: $scope.logisticsVehicle});
            }
          }
        }
      }
    })
  }

  availableLogisticVehiclesForBinding(branchIds?, attachedLogisticsVehicles?, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/available-logstics-vehicles-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {
        $scope.branchIds = branchIds;
        $scope.logisticsVehicle = undefined;
        $scope.trailerLogisticsVehicle = undefined;
        $scope.LogisticsVehicleStatusType = LogisticsVehicleStatusType;
        $scope.vehicleType = VehicleType;
        $scope.LogisticsVehicleStatus = [LogisticsVehicleStatusType.Available, LogisticsVehicleStatusType.Allocated];

        if (attachedLogisticsVehicles) {
          const trailerLogisticsVehicles = _.filter(attachedLogisticsVehicles, v => {
            return v.vehicleTypeReference.type === $scope.vehicleType.Trailer
          });
          if (trailerLogisticsVehicles.length) {
            $scope.trailerLogisticsVehicle = trailerLogisticsVehicles[0]
          }
          const logisticsVehicles = _.filter(attachedLogisticsVehicles, v => {
            return v.vehicleTypeReference.type !== $scope.vehicleType.Trailer;
          });
          if (logisticsVehicles.length) {
            $scope.logisticsVehicle = logisticsVehicles[0]
          }
        }

        $scope.cancel = self.$mdDialog.cancel;
        $scope.confirm = confirm;

        // ******************************
        // External methods
        // ******************************


        $scope.onLogisticsVehicleSelect = (logisticsVehicle) => {
          $scope.logisticsVehicle = logisticsVehicle;
        }

        $scope.onTrailerLogisticVehicleSelect = (trailerLogisticsVehicle) => {
          $scope.trailerLogisticsVehicle = trailerLogisticsVehicle;
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              const allLogisticsVehicles = [];

              if ($scope.logisticsVehicle) {
                allLogisticsVehicles.push($scope.logisticsVehicle)
              }

              if ($scope.trailerLogisticsVehicle) {
                allLogisticsVehicles.push($scope.trailerLogisticsVehicle)
              }

              self.$mdDialog.hide(allLogisticsVehicles);
            }
          }
        }


      }
    })
  }


  selectVehicleStatusChangeReason(logisticsVehicle: LogisticsVehicle, vehicleStatus: LogisticsVehicleStatusType, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/select-vehicle-status-change-reason-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {
        $scope.logisticsVehicle = logisticsVehicle;
        $scope.vehicleStatus = vehicleStatus;
        $scope.statusChangeReason = undefined;

        $scope.cancel = self.$mdDialog.cancel;
        $scope.confirm = confirm;

        // ******************************
        // External methods
        // ******************************

        $scope.onReasonChanged = (vehicleStatusChangeReason) => {
          $scope.statusChangeReason = vehicleStatusChangeReason;
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.statusChangeReason);
            }
          }
        }

      }
    })
  }

  deleteVehicleConfirmDialog(logisticVehicle: LogisticsVehicle, logisticsVehicleResources?: any, logisticVehicleAgents?:AgentModel[], event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/delete-vehicle-confirm-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.logisticVehicle = logisticVehicle;
        $scope.logisticsVehicleResources = logisticsVehicleResources;
        $scope.logisticVehicleAgents = logisticVehicleAgents;

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.onConfirm = () => {
          self.$mdDialog.hide();
        }

      }
    })
  }
}

angular
  .module('bringoz.admin.logistics-vehicle')
  .service('logisticsVehiclesDialogsService', LogisticsVehiclesDialogsService);
